import { render } from "./MaintenanceRequest.vue?vue&type=template&id=9c0d5d4a&scoped=true"
import script from "./MaintenanceRequest.vue?vue&type=script&lang=js"
export * from "./MaintenanceRequest.vue?vue&type=script&lang=js"

import "./MaintenanceRequest.vue?vue&type=style&index=0&id=9c0d5d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0d5d4a"]])

export default __exports__